import { defineMessages } from 'react-intl';

type MessageKeys = 'yesterday' | 'now';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		yesterday: {
			id: 'ai-mate.date-time-utils.time.yesterday',
			defaultMessage: 'Yesterday',
			description: 'Relative time label, yesterday',
		},
		now: {
			id: 'ai-mate.date-time-utils.time.now',
			defaultMessage: 'Just now',
			description: 'Relative time label, less than 1 minute',
		},
	});

export default message;
